import { useContext } from 'react'
import { Box } from '@mui/material'

import LanguageContext from "../../../contexts/LanguageContext"

/* Roadmap Nawal, « phrase d'insight auto » (03/09/2026).
 *
 * La logique existait deja, mais seulement dans le PDF : le Rapport d'impact
 * genere depuis hier une phrase de synthese a partir des chiffres reels. On la
 * porte a l'ecran, avec exactement les memes regles, pour que l'admin client
 * lise en une ligne ce que disent ses graphes sans avoir a exporter.
 *
 * Aucune donnee inventee : tout vient des tranches du graphe de connaissance et
 * de la liste des competences deja calculees par l'ecran. */

const nombre = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

/* Meme seuil que le Rapport d'impact : une competence bouge a partir de
   2 points, en dessous c'est du bruit de mesure. */
const SEUIL_MOUVEMENT = 2

export const construirePhrase = ({ etudiants, connaissance, competences, textes }) => {
  const avant = nombre(connaissance?.avant)
  const apres = nombre(connaissance?.apres)
  const gain = Math.round(apres) - Math.round(avant)
  const liste = Array.isArray(competences) ? competences : []

  const hausses = liste.filter((c) => Math.round(nombre(c.apres)) - Math.round(nombre(c.avant)) >= SEUIL_MOUVEMENT).length
  const baisses = liste.filter((c) => Math.round(nombre(c.apres)) - Math.round(nombre(c.avant)) <= -SEUIL_MOUVEMENT).length
  const n = nombre(etudiants)

  if (n <= 0) return null   // rien a dire sur une promotion vide

  const remplir = (modele) => String(modele || "")
    .replace("{n}", n)
    .replace("{gain}", gain >= 0 ? "+" + gain : String(gain))
    .replace("{hausses}", hausses)
    .replace("{baisses}", baisses)
    .replace("{sHausses}", hausses > 1 ? "s" : "")
    .replace("{sBaisses}", baisses > 1 ? "s" : "")
    .replace("{sEtudiants}", n > 1 ? "s" : "")

  if (hausses > 0 && baisses > 0) return remplir(textes?.mixte)
  if (hausses > 0) return remplir(textes?.hausse)
  if (baisses > 0) return remplir(textes?.reajustement)
  return remplir(textes?.stable)
}

const PhraseInsight = ({ etudiants, connaissance, competences }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  const textesLangue = languageValues?.adminDashboard?.mappingPage?.insight || {}
  const textes = Object.keys(textesLangue).reduce((acc, cle) => {
    acc[cle] = textesLangue[cle]?.[actLanguage]
    return acc
  }, {})

  const phrase = construirePhrase({ etudiants, connaissance, competences, textes })
  if (!phrase) return null

  return (
    <Box sx={{
      marginTop: "20px",
      padding: ["14px 16px", "16px 20px"],
      background: "white",
      border: "1px solid #E7E7E7",
      borderLeft: "3px solid #D85A30",
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
    }}>
      <Box sx={{ color: "#D85A30", fontSize: ["15px", "17px"], lineHeight: 1.4, flexShrink: 0 }}>{'◆'}</Box>
      <Box sx={{ color: "text.black", fontSize: ["14px", "15px", "15px", "16px"], lineHeight: "150%" }}>
        {phrase}
      </Box>
    </Box>
  )
}

export default PhraseInsight
